import AES from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';

import { getSiteHost } from '@/apis/hosts';
import {
  setToken,
  getToken,
  removeToken,
  setTestUser,
  removeTestUser,
} from '@/apis/util';
import { history } from 'umi';
import { getQueryString } from '@hll/eapp-utils';
import { isStaticPage } from '@/utils/static';
import { ENV } from '@/config/env';
import { clearAllExportBadgeCache } from '@/hooks/useExportBadge';
import { MessageWarning } from '@/components';

const removeTestUserFromHash = (hash: string) => {
  const currentHash = hash.replace('#/', '/');
  const queryStartIndex = currentHash.indexOf('?');
  if (queryStartIndex === -1) {
    return currentHash;
  }

  const path = currentHash.slice(0, queryStartIndex);
  const query = currentHash.slice(queryStartIndex + 1);
  const nextQuery = query
    .split('&')
    .filter(Boolean)
    .filter((item) => {
      const [key] = item.split('=');
      return key && key !== 'test_user';
    })
    .join('&');

  return nextQuery ? `${path}?${nextQuery}` : path;
};

export const noLoginProcess = () => {
  // 静态、免登页面不跳转到登录
  if (isStaticPage()) {
    return;
  }

  removeToken();
  removeTestUser();
  // 切换账号时清空所有导出记录徽标缓存
  clearAllExportBadgeCache();
  if (ENV !== 'prod') {
    window.location.href = `${getSiteHost()}?redirectOrigin=${encodeURIComponent(window.location.origin)}`;
  } else {
    window.location.href = getSiteHost();
  }
};

// 独立的登录页面，无法在未登录下进入系统，
// 因为 token 通过 url 参数传递，通过对称加密加密一次
const secretKey = 'ablock1abcde3dd3dd4lkjk5798k3n3l5mb3d3u4io5p5t480cddh';
const tokenEncrypted = getQueryString('token')
  ? decodeURIComponent(getQueryString('token'))
  : '';
const tokenIsDecrypted = getQueryString('tokenIsDecrypted');
const testUser = getQueryString('test_user')
  ? decodeURIComponent(getQueryString('test_user'))
  : '';
let tokenDecrypted = tokenEncrypted;
if (testUser) {
  setTestUser(testUser);
}
// url 传递了 token, 本地存储起来
if (tokenEncrypted) {
  if (!tokenIsDecrypted) {
    // 解密
    const tokenJson = AES.decrypt(tokenEncrypted, secretKey).toString(encUtf8);
    // token 格式： JSON.stringify({token: xxxx})
    // 套一层对象并用 JSON.stringify 源于一个错误 error: malformed utf-8 data， 具体见以下链接
    // https://stackoverflow.com/questions/58111929/why-i-get-malformed-utf-8-data-error-on-crypto-js
    tokenDecrypted = JSON.parse(tokenJson).token;
  }
  const storageToken = getToken();
  setToken(tokenDecrypted);
  // 登录时清空所有导出记录徽标缓存
  clearAllExportBadgeCache();
  if (tokenDecrypted !== storageToken) {
    // 旧版pc已登录态登录不重置
    localStorage.removeItem('wsList'); // 重置推送页面
  }
  const pwdValidate = getQueryString('pwdValidate') || '';
  if (pwdValidate === '1') {
    MessageWarning('密码风险高,请在"个人中心"重设密码');
  };
  // 安全问题，url中去掉token信息
  let currentHash = window.location.hash;
  currentHash = currentHash.replace('#/', '/');
  currentHash = currentHash.replace(`token=${tokenEncrypted}`, '');
  currentHash = currentHash.replace(`pwdValidate=${pwdValidate}`, '');
  currentHash = removeTestUserFromHash(currentHash);
  history.replace(currentHash);
} else {
  if (testUser) {
    const currentHash = removeTestUserFromHash(window.location.hash);
    history.replace(currentHash);
  }
  // url 没有传递，本地也没有存储，跳转到登录页面（不需要通过接口返回 未登录 做跳转）
  const tokenStored = getToken();
  if (!tokenStored) {
    noLoginProcess();
  }
}
